import { Action, createReducer, on } from '@ngrx/store'
import { load_dashboard_success } from '../action/dashboard.action'
import { DashboardState, initialUserDashboardState } from '../state/dashboard.state'

export function dashboardReducer(state: DashboardState, action: Action) {
  return _dashboardReducer(state, action)
}

const _dashboardReducer = createReducer(
  initialUserDashboardState,
  on(load_dashboard_success, (state, dashboardAPIData) => {
    return {
      ...state,
      announcements: dashboardAPIData.announcements,
      calendarEvents: dashboardAPIData.calendarEvents
    }
  })
)
